import React, { useContext } from 'react';
import classnames from 'classnames';
import { ListerContext } from '../../listerContext';
import { ListerActionTypes } from '../../listerReducer';
import useModal from '../../hooks/useModal';
import FiltersButton from './buttons/filtersButton';
import CloseButton from './buttons/closeButton';
import ViewResultsButton from './buttons/viewResultsButton';
import CollectionsList from '../collectionsList/CollectionsList';
import { ResetFiltersButtonSM } from './buttons/resetButton';
import Facets from './facets';
import styles from './facetsMenu.module.pcss';

function FacetsMenu(): React.ReactElement {
  const [{ isListerDisabled, breadcrumbs, isFacetsModalDisplayed, results }, dispatch] = useContext(ListerContext);
  const isNoFiltersSelected = !breadcrumbs.length;
  const noResults = !results.length;
  const facetsDisplayHandler = (): void => {
    dispatch({
      type: ListerActionTypes.SET_IS_FACETS_MODAL_DISPLAYED,
      isFacetsModalDisplayed: !isFacetsModalDisplayed
    });
  };

  useModal();

  return (
    <>
      <FiltersButton isListerDisabled={isListerDisabled} facetsDisplayHandler={facetsDisplayHandler} />

      <aside className={classnames(styles['facets-menu'], { [styles['facets-menu--modal']]: isFacetsModalDisplayed })}>
        <div className={styles['facets-menu__head']}>
          <CloseButton facetsDisplayHandler={facetsDisplayHandler} isListerDisabled={isListerDisabled} />
        </div>
        <div className={styles['facets-menu__body']}>
          <Facets />
          <CollectionsList />
        </div>
        <div className={styles['facets-menu__foot']}>
          <ViewResultsButton
            facetsDisplayHandler={facetsDisplayHandler}
            isListerDisabled={isNoFiltersSelected}
            noResults={noResults}
          />
          <ResetFiltersButtonSM isDisabled={isNoFiltersSelected} />
        </div>
      </aside>
    </>
  );
}

export default FacetsMenu;
